import { isNode } from "@use/is-node";

/**
 * Helper that'll parse the given HTML string into a DOM node tree, which we can
 * work through when converting input to react output.
 */
export function parseHtml(
  html: string,
  mimeType: DOMParserSupportedType = "text/html",
  decodeHTMLEntities?: boolean
): Document | Node {
  const decoder: (html: string) => string = isNode()
    ? eval("require('html-entities').AllHtmlEntities.decode") // tslint:disable-line no-eval no-unsafe-any
    : (original) => original;
  // Create a new parser (on node-based environments, we'll need to fallback
  // to jsdom and hope that it works as expected)
  const domParser: DOMParser = isNode()
    ? // In order to prevent Webpack from bundling jsdom, we're going to
      // use an eval statement (that way we wont pollute the bundle sent
      // to browsers with jsdom, when they already have a native
      // DOMParser implementation)
      eval("new (new (require('jsdom').JSDOM())).window.DOMParser()") // tslint:disable-line no-eval no-unsafe-any
    : new DOMParser();

  // Parse the document!
  const doc = domParser.parseFromString(
    decodeHTMLEntities ? decoder(html) : html,
    mimeType
  );

  // In browser-based environments, we'll have an entire DOM returned,
  // starting from the wrapping <html>-tag - where as in node.js we'll get a
  // direct reference to the set of root nodes
  return doc.body ? doc.body : doc;
}
